module.exports = __webpack_public_path__ + "static/media/resume.9b505554.pdf";